// This file is generated by scripts/generate-terrain-sprite-manifest.mjs.
// Do not edit by hand.

export const GENERATED_TERRAIN_SPRITE_PNG_IDS = [
  "forest",
  "mountain",
  "plain",
  "road",
  "water"
];
export const GENERATED_TERRAIN_ANIMATED_IDS = [
  "road",
  "water"
];
